'use strict';
import classNames from 'classnames';
import * as T from 'prop-types';
import React from 'react';
import {List} from '../../../components/lists/List';
import {getCollection, getId} from '../../../core-utilities/domain/ReduxUtils';
import {getMessagesFromProps, I18nComponent} from '../../../core-utilities/react-i18n';
import {getItemClass} from '../../../core-utilities/redux';
import {MILESTONE_COLLECTION} from '../../../projects/domain/MilestoneDomain';
import {COLLECTION as ASSET_TASK_COLLECTION} from '../../domain/AssetTaskDomain';
import {COLLECTION as TASK_COLLECTION} from '../../domain/TaskDomain';
import {isTaskType, TaskType} from '../../enums/TaskType';
import {logger} from '../logger';
import {MilestoneItem} from '../MilestoneItem';
import {TaskItem} from '../TaskItem';
import {TemplateTaskItem} from '../TemplateTaskItem';


function BaseTaskListView(props) {
  return (
    <List
      className={classNames("TaskList", props.className)}
      useScroll={props.useScroll}
      flipped={false}
      autoScroll={false}
      useAnimation={false}
      mode={props.mode}
      onLoadMore={props.onLoadMore}
      transitionGroupClass={props.transitionGroupClass}
    >
      {props.list ? props.list.map(model => renderItem(props, model)) : null}
    </List>
  );
}

function renderItem(props, model) {
  const collection = getCollection(model);
  const id = getId(model);

  switch (collection) {
    case TASK_COLLECTION:
    case ASSET_TASK_COLLECTION:
      if (props.taskType === TaskType.TEMPLATE) {
        return (
          <TemplateTaskItem
            className={classNames(props.itemClassName, getItemClass(model))}
            key={id}
            model={model}
            onClick={props.onTaskClick}
            onContextMenu={props.onTaskContextMenu}
          />
        );
      } else {
        return (
          <TaskItem
            className={classNames(props.itemClassName, getItemClass(model))}
            key={getId(model)}
            isCardMode={props.isCardMode}
            userId={props.userId}
            model={model}
            onClick={props.onTaskClick}
            onContextMenu={props.onTaskContextMenu}

            init={props.init}
            {...getMessagesFromProps(props, TaskItem.messageProps)}
          />
        );
      }
    case MILESTONE_COLLECTION:
      return (
        <MilestoneItem
          className={classNames("TaskList__milestoneItem", getItemClass(model))}
          key={id}
          taskType={props.taskType}
          model={model}
          canAddTask={props.canAddTask}
          supportsDownload={props.supportsDownload}
          canDownloadFiles={props.canDownloadFiles}

          onAddTask={props.onMilestoneAddTask}
          onClickVisibilityButton={props.onClickVisibilityButton}
          onClickOptionsButton={props.onClickOptionsButton}
          onDownloadAllFiles={props.onMilestoneDownloadAllFiles}

          {...getMessagesFromProps(props, MilestoneItem.messageProps)}
        />
      );
    default:
      logger.warn(`Invalid collection for item: ${collection}`);
      return null;
  }
}

BaseTaskListView.propTypes = {
  className: T.string,
  transitionGroupClass: T.string,
  itemClassName: T.string,

  taskType: isTaskType.isRequired,
  canAddTask: T.bool.isRequired,
  supportsDownload: T.bool.isRequired,
  canDownloadFiles: T.bool.isRequired,

  onMilestoneAddTask: T.func.isRequired,
  onClickVisibilityButton: T.func.isRequired,
  onClickOptionsButton: T.func.isRequired,
  onMilestoneDownloadAllFiles: T.func.isRequired,

  init: T.bool,
};

BaseTaskListView.defaultProps = {
  init: true,
};

export const TaskListView = I18nComponent(BaseTaskListView, [
  ...MilestoneItem.messages,
  ...TaskItem.messages,
]);



// WEBPACK FOOTER //
// ./src/js/tasks/components/TaskList/TaskListView.js